import { ProgressIndicator } from "@forge/common";
import "./progressbar.scss";
import { BodyText } from "../title-container/LText";

const ProgressBarComponent = ({
  consumedSize,
  allocatedSize,
}: {
  consumedSize: string;
  allocatedSize: string;
}) => {
  let allosize = allocatedSize;

  const AllocatedSize = parseInt(allosize?.slice(0, allosize?.length - 2));

  const convertDataGB = (val: any, type: any) => {
    let gbVal;
    if (type?.toLowerCase() === "kb") {
      gbVal = val / 1024 / 1024;
    }
    if (type?.toLowerCase() === "mb") {
      gbVal = val / 1024;
    }
    return gbVal;
  };

  const splitFun = (input: any) => {
    const splitArray = input.match(/([\d\.]+)(.*)/);
    return {
      numeric: splitArray?.[1],
      nonnumeric: splitArray?.[2],
    };
  };

  const blobFlow = () => {
    if (consumedSize === "0Bytes") {
      return 0;
    } else if (consumedSize) {
      let consize = splitFun(consumedSize);
      if (consize.nonnumeric.toLowerCase() !== "gb") {
        let resConsume = convertDataGB(consize.numeric, consize.nonnumeric);
        if (resConsume) {
          return resConsume;
        }
      } else {
        if (consize.numeric) {
          return parseFloat(consize.numeric);
        }
      }
    }
    return 0;
  };

  return (
    <div className="flex">
      <BodyText title={`Storage Space:`} bold className="flex justify-center mr-3" />
      <div className="grid grid-cols-1 items-end justify-start">
        <div className="progress-bar-component items-center justify-start flex-col">
          <div>
            <div data-testid="storage-usage">
              <BodyText
                title={`${consumedSize} of ${allocatedSize} (${(
                  (blobFlow() / AllocatedSize) *
                  100
                ).toFixed(2)}%)`}
              />
            </div>
            <ProgressIndicator
              id="progress-bar"
              data-testid="progress-bar"
              fileName="precipitation-model.csv"
              fileSize={AllocatedSize}
              size="regular"
              uploaded={blobFlow()}
              className={`w-[220px] xl-mid:w-[320px] xl-high:w-[320px] xl-high:mt-2`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBarComponent;
